import React, { useState } from 'react';
import Truncate from 'react-truncate';
import { Button } from '@material-ui/core';


export const ReadMore = ({ lines, readMoreText, children }) => {
  const [state, setState] = useState({
    expanded: false,
    truncated: false,
  });
  return (
    <Truncate
      lines={!state.expanded && lines}
      ellipsis={<span>... <Button onClick={event => { setState({ ...state, expanded: !state.expanded }); event.preventDefault(); }}>{readMoreText}</Button></span>}>
      {children}
    </Truncate>
  );
}

export const getMoney = price => (
  price ? price.toLocaleString(undefined, { style: 'currency', currency: 'SEK', currencyDisplay: 'code' }) : price
)

export const getQuantity = quantity => (
  quantity ? quantity.toLocaleString(undefined, { style: 'decimal', minimumFractionDigits: 3, maximumFractionDigits: 3 }) : quantity
)